module.exports = __webpack_public_path__ + "img/Plus.5e06110a.svg";